var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyBox = function SvgHappyBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 102,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.644 59.837c1.736 0 3.144-1.419 3.144-3.169S50.38 53.5 48.644 53.5c-1.736 0-3.144 1.419-3.144 3.168 0 1.75 1.407 3.169 3.144 3.169zM80.644 59.837c1.736 0 3.143-1.419 3.143-3.169S82.38 53.5 80.644 53.5c-1.737 0-3.144 1.419-3.144 3.168 0 1.75 1.407 3.169 3.144 3.169z",
    fill: "#363840"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.338.257a2.5 2.5 0 013.063.69L42.924 18h43.152L99.599.947a2.5 2.5 0 013.063-.69l24.942 12.273a2.5 2.5 0 01.666 4.009L106 38.86V99.5a2.5 2.5 0 01-2.5 2.5h-78a2.5 2.5 0 01-2.5-2.5V38.86L.73 16.54a2.5 2.5 0 01.666-4.01L26.338.258zM28 40v57h73V40H28zm75.874-6.088l18.393-18.436-20.003-9.842-11.46 14.45 13.07 13.828zM97.634 35L86.108 23H42.891L31.367 35h66.266zM38.195 20.084l-11.46-14.45-20.003 9.842 18.393 18.436 13.07-13.828z",
    fill: "#363840"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 64.999V67.5c0 4.447-1.748 8.14-4.66 10.692C72.465 80.714 68.6 82 64.5 82 55.204 82 49 75.591 49 67.5V65H77.499L80 64.999zM54.313 70c1.035 3.99 4.602 7 10.187 7 3.08 0 5.716-.964 7.544-2.567 1.267-1.11 2.218-2.586 2.668-4.433H54.313z",
    fill: props.fill
  }));
};
export default SvgHappyBox;